import { render, staticRenderFns } from "./changeMes.vue?vue&type=template&id=a51f4b16&scoped=true&"
import script from "./changeMes.vue?vue&type=script&lang=js&"
export * from "./changeMes.vue?vue&type=script&lang=js&"
import style0 from "./changeMes.vue?vue&type=style&index=0&id=a51f4b16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51f4b16",
  null
  
)

export default component.exports